<template>
  <div class="GoodsTable">
    <vxe-table
      border
      ref="xTable1"
      size="mini"
      height="252"
      align="center"
      :data="tableData"
      @cell-dblclick="rowdblclick"
      @cell-click="cellClickEvent"
      @select-all="selectAllEvent"
      @select-change="selectChangeEvent"
      highlight-current-row
      highlight-hover-row
      resizable
      show-overflow
    >
      <vxe-table-column align="center" width="50">
        <template v-slot:header="{ column }">
          <!-- <i class="el-icon-s-tools" style="color:#2594ff;font-size:18px"></i> -->
          <span style="font-size:12px">行号</span>
        </template>
        <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
      </vxe-table-column>
      <vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
      <template v-for="(item,index) in configData">
        <vxe-table-column width="150" align="center" :key="index" :field="item.field" :title="item.label"></vxe-table-column>
      </template>
    </vxe-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value: false,
      data: this.tableData,
      multipleSelection: [],
      direction: 1
    };
  },
  props: {
    max: String, //表格最大高度
    tableData: Array, //table表格数据
    configData: {
      type: Array,
      default: () => {
        return [
          { label: "商品名称", field: "FullName" },
          { label: "商品编号", field: "BaseCode" },
          { label: "可用库存", field: "AQty" },
          { label: "单位", field: "UnitName" },
          { label: "规格", field: "Standards" },
          { label: "型号", field: "Model" },
          { label: "产地", field: "ProArea" }
        ];
      }
    } //配置项数据
  },
  methods: {
    // 滚动条 上移
    highlightcurren(dire) {
      if (this.direction - 1 != -1) {
        this.direction = this.direction - 1;
        this.multipleSelection = [this.$refs.xTable1.data[this.direction]];
        this.$refs.xTable1.setCurrentRow(this.tableData[this.direction]);
        this.$refs.xTable1.scrollToRow(this.$refs.xTable1.getCurrentRow());
      }
    },
    // 滚动条 下移
    highlightcurrens(dire) {
      if (this.direction + 1 != this.tableData.length) {
        this.direction = this.direction + 1;
        this.multipleSelection = [this.$refs.xTable1.data[this.direction]];
        this.$refs.xTable1.setCurrentRow(this.tableData[this.direction]);
        this.$refs.xTable1.scrollToRow(this.$refs.xTable1.getCurrentRow());
      }
    },
    cellClickEvent() {
      //   console.log("单元格点击事件");
      //   this.$refs.xTable1.setCurrentRow(this.tableData[0]);
    },
    selectAllEvent({ selection }) {
      this.multipleSelection = selection;
      this.$emit("SelectionChange", this.multipleSelection);
    },
    selectChangeEvent({ selection }) {
      this.multipleSelection = selection;
      this.$emit("SelectionChange", this.multipleSelection);
    },
    enterArrow() {
      this.$emit("rowdblclick", this.multipleSelection);
    },
    // 双击行
    rowdblclick({ row }) {
      this.multipleSelection = [];
      this.multipleSelection.push(row);
      this.$emit("rowdblclick", this.multipleSelection);
    }
  },
  computed: {},
  watch: {
    tableData: {
      handler(newValue, oldValue) {
        this.data = newValue;
      },
      deep: true
    }
  },
  mounted() {
    this.$on("footer", val => {
      this.highlightcurren();
      this.highlightcurrens();
      this.enterArrow();
    });
  }
};
</script>
<style lang="less" scoped>
.GoodsTable {
  .header_sty {
    width: 100%;
  }
  .tabone_sty {
    width: 100%;
    height: 30px;
    .span_inner_sty {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .icon_sty {
    cursor: pointer;
  }
  .icon_sty:hover {
    color: #2594ff;
  }
  // 重写单元格
  .el-table--small td,
  .el-table--small th {
    padding: 0px 0;
  }
  .el-table .cell,
  .el-table th div,
  .el-table--border td:first-child .cell,
  .el-table--border th:first-child .cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  .ub {
    display: -webkit-box !important;
    display: box !important;
    position: relative;
  }
  .ub-ac {
    -webkit-box-align: center;
    box-align: center;
  }
  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ccc;
  }

  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #ededed;
  }

  .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 1px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 10px;
  }
  .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ccc;
  }
  .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #ededed;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Table/GoodsTable/GoodsTable.vue